var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "siderbar" },
    [
      _c("avatar"),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical-demo",
          attrs: {
            mode: "vertical",
            "default-active": _vm.activeMenu,
            "background-color": "#242e37",
            "text-color": "#D7DEE4",
            "active-text-color": "#ff6224",
            "unique-opened": ""
          }
        },
        _vm._l(_vm.permission_routes, function(route) {
          return _c("sidebar-item", {
            key: route.path,
            attrs: { item: route, "base-path": route.path }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-188a3c40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188a3c40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SiderBar/index.vue
// module id = null
// module chunks = 